<template>
  <div class="player-wrapper text-white">
    <img src="../assets/images/volvo-penta-white.svg" alt="Volvo Penta" class="white-logo position-absolute" v-if="codeValid && mode == 'live' || mode == 'test'">

    <video autoplay muted loop id="myVideo" style="width: 100%; height: 100%; display: block;">
      <source src="../assets/video/volvo-penta.mp4" type="video/mp4">
    </video>

    <div class="player-container position-absolute" v-if="codeValid && mode == 'live' || mode == 'test'">
      <div class="embed-responsive embed-responsive-16by9">
        <div class="embed-responsive-item">
          <jwplayer></jwplayer>
        </div>
      </div>
    </div>

    <div class="embed-responsive embed-responsive-16by9 position-absolute" v-else-if="codeValid && mode == 'offline'">
      <div class="embed-responsive-item d-flex flex-column align-items-center justify-content-center">
        <div class="h4 m-0">Vi är inte live för tillfället</div>
      </div>
    </div>

    <div class="embed-responsive embed-responsive-16by9 position-absolute" v-else-if="(codeValid && mode == 'pre') || !codeValid">
      <div class="embed-responsive-item d-flex flex-column align-items-center justify-content-center">
        <vue-countdown :time="time" :transform="transformTime" v-if="time">
          <template slot-scope="props">
            <div class="m-0 timer-props d-flex flex-column">
              <div class="d-flex justify-content-between">
                <span class="text-center">
                  <h1>{{ props.days }}</h1>
                  <span>{{ props.days == 1 ? "day" : "days" }}</span>
                </span>
                <h1>:</h1>
                <span class="text-center">
                  <h1>{{ props.hours }}</h1>
                  <span>{{ props.hours == 1 ? "hour" : "hours" }}</span>
                </span>
                <h1>:</h1>
                <span class="text-center">
                  <h1>{{ props.minutes }}</h1>
                  <span>{{ props.hours == 1 ? "minute" : "minutes" }}</span>  
                </span>
                <h1>:</h1>
                <span class="text-center">
                  <h1>{{ props.seconds }}</h1>
                  <span>{{ props.hours == 1 ? "second" : "seconds" }}</span>
                </span>
              </div>
            </div>
          </template>
        </vue-countdown>
      </div>
    </div>

    <div class="embed-responsive embed-responsive-16by9 position-absolute" v-else-if="mode == 'post'">
      <div class="embed-responsive-item d-flex flex-column align-items-center justify-content-center">
        <div class="h4 m-0">Thanks for watching!</div>
      </div>
    </div>

    <div class="embed-responsive embed-responsive-16by9 position-absolute" v-else-if="mode == 'ondemand'">
      <iframe src="https://player.buster.se/video/NYWQSDLLaKqERJSDY" class="embed-responsive-item iframe-border" allowtransparency="true" frameborder="0" scrolling="no" seamless allowfullscreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen></iframe>
    </div>
  </div>

  <!--
  <div class="player my-5" :key="mode">
    <div class="container">
      <section class="row">
        <div class="col" v-if="mode == 'live' || mode == 'test'">
          <div class="embed-responsive embed-responsive-16by9 bg-dark text-white">
            <div class="embed-responsive-item">
              <jwplayer></jwplayer>
            </div>
          </div>
        </div>

        <div class="col" v-else-if="mode == 'offline'">
          <div class="embed-responsive embed-responsive-16by9 bg-dark text-white">
            <div class="embed-responsive-item d-flex flex-column align-items-center justify-content-center">
              <div class="h4 m-0">Vi är inte live för tillfället</div>
            </div>
          </div>
        </div>

        <div class="col" v-else-if="mode == 'pre'">
          <div class="embed-responsive embed-responsive-16by9 bg-dark text-white">
            <div class="embed-responsive-item d-flex flex-column align-items-center justify-content-center">
              <vue-countdown :time="time" v-if="time">
                <template slot-scope="props">
                  <div class="h4 m-0">
                    {{ props.days }} {{ props.days == 1 ? "dag" : "dagar" }},
                    {{ props.hours }} {{ props.hours == 1 ? "timme" : "timmar" }},
                    {{ props.minutes }} {{ props.hours == 1 ? "minut" : "minuter" }},
                    {{ props.seconds }} {{ props.hours == 1 ? "sekund" : "sekunder" }}
                  </div>
                </template>
              </vue-countdown>
            </div>
          </div>
        </div>

        <div class="col" v-else-if="mode == 'post'">
          <div class="embed-responsive embed-responsive-16by9 bg-dark text-white">
            <div class="embed-responsive-item d-flex flex-column align-items-center justify-content-center">
              <div class="h4 m-0">Tack för att du tittade!</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
  -->
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  import VueCountdown from "@chenfengyuan/vue-countdown"
  import Jwplayer from "@/components/jwplayer"

  export default {
    name: "player",
    components: { VueCountdown, Jwplayer },
    props: {
      mode: {
        type: String,
        default: "offline"
      }
    },
    data() {
      return {
        loading: true,
        code: null,
        eventStart: "2020-11-18T13:00:00",
        eventTimezone: "Europe/Stockholm",
        time: null,
      }
    },
    computed: {
      codeValid() {
        // return this.code
        return true
      },
      eventStartObject() {
        return this.$DateTime.fromISO(this.eventStart, { zone: this.eventTimezone })
      }
    },
    methods: {
      transformTime(props) {
        Object.entries(props).forEach(([key, value]) => {
          let digits = (value != 0 && value < 10) ? `0${value}` : value
          if(key == "seconds") {
            digits = (value < 10) ? `0${value}` : value
          }
          props[key] = `${digits}`
        })

        return props
      },
      closePlayer() {
        this.$store.commit("setCurrentCode", { codeString: null })
      }
    },
    async mounted() {
      if(this.$store.state.currentCode) {
        await this.$bind("code", firebase.firestore().collection(`codes`).doc(this.$store.state.currentCode))
      }

      let now = this.$DateTime.local().setZone(this.eventTimezone)
      let millis = this.eventStartObject.diff(now).toObject()

      this.time = millis.milliseconds

      this.loading = false
    }
  }
</script>

<style lang="scss" scoped>
  .timer-props {
    font-family: Arial, Helvetica, sans-serif;
    min-width: 300px;
    text-align: justify;

    h1 { font-size: 5rem; margin: 0; }
    span { font-size: 1.3rem; }
  }

  .player-container,
  .embed-responsive {
    top: 0;
    left: 0;
  }

  .player-container {
    width: 100%;
    height: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    @media (min-width: 768px) {
      width: 60%;
      height: auto;
    }
  }

  .white-logo {
    max-width: 150px;
    right: 30px;
    top: 30px;
  }
</style>